const conf: any = {
  prod: {
    segmentKey: "Db7qg80zZq79SffgRblhPHcSuBwraILN",
    ackoURL: "www.acko.com",
  },
  uat: {
    segmentKey: "OmV7jAWTCgzH5jCxRpM1UBbAJfGUsOOj",
    ackoURL: "www.ackodev.com",
  },
  local: {
    segmentKey: "OmV7jAWTCgzH5jCxRpM1UBbAJfGUsOOj",
    ackoURL: "www.ackodev.com",
  },
  dev: {
    segmentKey: "OmV7jAWTCgzH5jCxRpM1UBbAJfGUsOOj",
    ackoURL: "www.ackodev.com",
  },
};

export const getConfig = (envValue: any) => conf[envValue];
